import { EXPRESSION_TYPE_LABELS, type ExpressionType } from "@adpilot/shared";

const EXPRESSION_BY_LABEL = new Map(
  (Object.entries(EXPRESSION_TYPE_LABELS) as [ExpressionType, string][]).map(([key, label]) => [
    label,
    key,
  ]),
);

/**
 * 服务端派生的 targetLabel 对自动投放目标固定是英文匹配组名
 * (deriveTargetLabel → EXPRESSION_TYPE_LABELS);列表载荷只有 label 字符串,
 * 反查出 expressionType 才能本地化并标注"自动投放"。
 */
export function expressionTypeFromLabel(label: string): ExpressionType | null {
  return EXPRESSION_BY_LABEL.get(label) ?? null;
}

/** "Close match" → "自动投放 · 紧密匹配";非自动投放 label 原样返回。 */
export function localizedTargetLabel(
  label: string,
  t: (key: string, options?: Record<string, unknown>) => string,
): string {
  const expressionType = expressionTypeFromLabel(label);
  if (!expressionType) return label;
  return t("aiOperations:runDetail.decisionRecord.target.autoGroup", {
    group: t(`aiOperations:runDetail.decisionRecord.target.${expressionType}`),
  });
}
